export var DataRole;
(function (DataRole) {
    let Name;
    (function (Name) {
        Name["Names"] = "NAMES";
        Name["Values"] = "VALUES";
        Name["Records"] = "RECORDS";
        Name["DatePart"] = "DATE_PART";
        Name["DateTrunc"] = "DATE_TRUNC";
        Name["GeoLatitude"] = "GEO_LATITUDE";
        Name["GeoLongitude"] = "GEO_LONGITUDE";
    })(Name = DataRole.Name || (DataRole.Name = {}));
    function equals(type1, type2) {
        switch (type1.name) {
            case "NAMES":
                return type1.name === type2.name;
            case "VALUES":
                return type1.name === type2.name;
            case "RECORDS":
                return type1.name === type2.name;
            case "DATE_PART":
                return type1.name === type2.name && type1.unit === type2.unit;
            case "DATE_TRUNC":
                return type1.name === type2.name && type1.unit === type2.unit;
            case "GEO_LATITUDE":
                return type1.name === type2.name;
            case "GEO_LONGITUDE":
                return type1.name === type2.name;
            default:
                return false;
        }
    }
    DataRole.equals = equals;
    let Names;
    (function (Names) {
        function make() {
            return { name: "NAMES" };
        }
        Names.make = make;
    })(Names = DataRole.Names || (DataRole.Names = {}));
    let Values;
    (function (Values) {
        function make() {
            return { name: "VALUES" };
        }
        Values.make = make;
    })(Values = DataRole.Values || (DataRole.Values = {}));
    let Records;
    (function (Records) {
        function make() {
            return { name: "RECORDS" };
        }
        Records.make = make;
    })(Records = DataRole.Records || (DataRole.Records = {}));
    let DatePart;
    (function (DatePart) {
        function make(unit) {
            return { unit, name: "DATE_PART" };
        }
        DatePart.make = make;
    })(DatePart = DataRole.DatePart || (DataRole.DatePart = {}));
    let DateTrunc;
    (function (DateTrunc) {
        function make(unit) {
            return { unit, name: "DATE_TRUNC" };
        }
        DateTrunc.make = make;
    })(DateTrunc = DataRole.DateTrunc || (DataRole.DateTrunc = {}));
    let GeoLatitude;
    (function (GeoLatitude) {
        function make() {
            return { name: "GEO_LATITUDE" };
        }
        GeoLatitude.make = make;
    })(GeoLatitude = DataRole.GeoLatitude || (DataRole.GeoLatitude = {}));
    let GeoLongitude;
    (function (GeoLongitude) {
        function make() {
            return { name: "GEO_LONGITUDE" };
        }
        GeoLongitude.make = make;
    })(GeoLongitude = DataRole.GeoLongitude || (DataRole.GeoLongitude = {}));
})(DataRole || (DataRole = {}));
